import React from 'react';
import { SecurePdfViewer, SecurePdfDownload } from './SecurePdfViewer';

/**
 * SecurePdfViewDownload component that provides both view and download options
 * @param {Object} props
 * @param {string} props.href - PDF URL
 * @param {string} props.children - Link text
 * @param {string} props.className - CSS classes
 * @param {string} props.pageUrl - Current page URL
 * @param {Object} rest - Other props
 */
export function SecurePdfViewDownload({ href, children, className = '', pageUrl = null, ...rest }) {
  const isPdfLink = href && href.toLowerCase().endsWith('.pdf');
  
  if (!isPdfLink) {
    return (
      <a href={href} className={className} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <div className={`secure-pdf-controls ${className}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
      {/* Original link text - now clickable for viewing */}
      <SecurePdfViewer
        href={href}
        pageUrl={pageUrl}
        className="pdf-main-link"
        style={{ 
          color: '#c2a56b', 
          textDecoration: 'underline',
          cursor: 'pointer',
          marginRight: '10px'
        }}
        {...rest}
      >
        {children}
      </SecurePdfViewer>
      
      {/* View button */}
      <SecurePdfViewer
        href={href}
        pageUrl={pageUrl}
        className="pdf-view-btn"
        style={{ 
          padding: '4px 8px', 
          backgroundColor: 'transparent', 
          color: 'c2a56b', 
          textDecoration: 'none', 
          borderRadius: '4px',
          fontSize: '12px',
          border: '1px solid #c2a56b',
          cursor: 'pointer'
        }}
        {...rest}
      >
         View
      </SecurePdfViewer>
      
      {/* Download button */}
      <SecurePdfDownload
        href={href}
        pageUrl={pageUrl}
        className="pdf-download-btn"
        style={{ 
          padding: '4px 8px', 
          backgroundColor: 'transparent', 
          color: '#c2a56b', 
          textDecoration: 'none', 
          borderRadius: '4px',
          fontSize: '12px',
          border: '1px solid #c2a56b',
          cursor: 'pointer'
        }}
        {...rest}
      >
       Download
      </SecurePdfDownload>
    </div>
  );
} 